<script>
    import Teams from '@/services/Teams'
    import Swal from "sweetalert2";

    export default {
        props: {
            team_id: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                showModal: false,
                tryingToRemove: false,
            };
        },
        methods: {
            refreshTeams() { 
                this.$emit('onRefresh') //event from parent
            },
            async removeTeamData() {
                this.tryingToRemove = true;

                await Teams.removeTeamData(this.team_id)
                .then(() => {
                    this.refreshTeams()
                    //console.log(response.data.customer)
                    this.closeModal();
                    this.successmsg();
                    this.tryingToRemove = false;
                })
                .catch(error => {
                    //console.log(error.response.data.error);
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg( this.error )
                    this.tryingToRemove = false;
                })
            },

            closeModal() {
                this.showModal = false;
            },

            successmsg() {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Success",
                    showConfirmButton: false,
                    timer: 2000,
                });
            },

            failedmsg(msg) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: msg,
                    showConfirmButton: false,
                    timer: 5000,
                });
            },
        }
    };
</script>



<template>
    <b-modal  v-model="showModal" id="teams_remove_data" title="Delete Ticketing URL" title-class="font-18" centered>
        <form @submit.prevent="removeTeamData">
               
        </form>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="removeTeamData" :disabled="tryingToRemove">
                <b-spinner v-show="tryingToRemove" small></b-spinner>
                Remove</b-button>
        </template>
    </b-modal>
</template>